/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Block hash scrolling for ProductsList tabs while keeping native theme behavior.
  document.addEventListener(
    'click',
    function(evt) {
      var tabButton = evt.target && evt.target.closest ? evt.target.closest('[data-tab-button]') : null;
      var href;

      if (!tabButton) {
        return;
      }

      href = tabButton.getAttribute('href') || '';

      if (href.indexOf('#ProductsListItem--') !== 0) {
        return;
      }

      evt.preventDefault();
    },
    true
  );


  // ============================================================
  // Promowany produkt w mini-koszyku (zakup impulsowy)
  // ============================================================
  (function () {
    /**
     * Pobiera aktualny stan koszyka i aktualizuje stan checkboxa
     * oraz widoczność wiersza promowanego produktu.
     */
    function syncPromotedProductCheckbox() {
      var row = document.querySelector('[data-promoted-product-row]');
      if (!row) return;

      fetch(((window.theme && window.theme.routes && window.theme.routes.cart_url) ? window.theme.routes.cart_url : '/cart') + '.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var variantId = parseInt(row.getAttribute('data-variant-id'), 10);
          var checkbox = row.querySelector('[data-promoted-product-checkbox]');
          if (!checkbox) return;

          var inCart = cart.items.some(function (item) {
            return item.variant_id === variantId;
          });

          checkbox.checked = inCart;

          if (cart.item_count > 0) {
            row.classList.remove('hidden');
          } else {
            row.classList.add('hidden');
          }
        })
        .catch(function (err) { console.warn('Promoted product sync error:', err); });
    }

    /**
     * Obsługuje zmianę stanu checkboxa promowanego produktu.
     */
    function onPromotedCheckboxChange(checkbox) {
      var row = checkbox.closest('[data-promoted-product-row]');
      if (!row) return;

      var variantId = row.getAttribute('data-variant-id');
      checkbox.disabled = true;

      if (checkbox.checked) {
        fetch((window.theme && window.theme.routes && window.theme.routes.cart_add_url) ? window.theme.routes.cart_add_url : '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
          },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data && data.status) {
              throw data;
            }
            checkbox.disabled = false;
            if (window.cart && typeof window.cart.getCart === 'function') {
              window.cart.getCart();
            }
          })
          .catch(function (err) {
            console.warn('Promoted product add error:', err);
            checkbox.checked = false;
            checkbox.disabled = false;
          });
      } else {
        fetch(((window.theme && window.theme.routes && window.theme.routes.cart_url) ? window.theme.routes.cart_url : '/cart') + '.js')
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            var item = cart.items.find(function (i) {
              return String(i.variant_id) === String(variantId);
            });
            if (!item) {
              checkbox.disabled = false;
              return Promise.resolve();
            }
            return fetch((window.theme && window.theme.routes && window.theme.routes.cart_change_url) ? window.theme.routes.cart_change_url : '/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({ id: item.key, quantity: 0 })
            });
          })
          .then(function () {
            checkbox.disabled = false;
            if (window.cart && typeof window.cart.getCart === 'function') {
              window.cart.getCart();
            }
          })
          .catch(function (err) {
            console.warn('Promoted product remove error:', err);
            checkbox.checked = true;
            checkbox.disabled = false;
          });
      }
    }

    // Delegacja zdarzeń — obsługa zmiany stanu checkboxa promowanego produktu
    document.addEventListener('change', function (evt) {
      if (evt.target && evt.target.hasAttribute('data-promoted-product-checkbox')) {
        onPromotedCheckboxChange(evt.target);
      }
    });

    // Synchronizuj stan checkboxa po każdej aktualizacji koszyka
    document.addEventListener('theme:cart:added', function () {
      syncPromotedProductCheckbox();
    });

    // Synchronizacja przy załadowaniu i otwarciu szuflady koszyka
    document.addEventListener('theme:cart:loaded', syncPromotedProductCheckbox);
    document.addEventListener('theme:cart:open', syncPromotedProductCheckbox)
  })();


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
